import { Button, FormControl, IInputProps, Input, Stack, Text, VStack } from 'native-base'
import { Eye, EyeSlash } from 'phosphor-react-native'
import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface PasswordInputProps {
  label?: string
  value?: string
  required?: boolean
  errorMessage?: string
  isAutocomplete?: boolean
  showLabel?: boolean
  onInitRef?: (ref: React.RefObject<View>) => void
}

export const PasswordInput: FC<PasswordInputProps & IInputProps> = ({
  label,
  value,
  required,
  errorMessage,
  showLabel = true,
  placeholder,
  onInitRef,
  isAutocomplete = true,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const ref = React.useRef<View>(null)
  const { t } = useTranslation()

  useEffect(() => {
    if (onInitRef) {
      onInitRef(ref)
    }
  }, [])

  return (
    <VStack width="full" space="3">
      <FormControl isRequired={required} isInvalid={!!errorMessage}>
        <Stack>
          {showLabel ? (
            <FormControl.Label>
              <Text color={'gray.600'} fontWeight={'bold'}>
                {label ?? t('inputs.password.label')}
              </Text>
            </FormControl.Label>
          ) : null}
          <Input
            ref={ref}
            autoComplete={isAutocomplete ? 'password' : 'password-new'}
            testID="password-input"
            type={showPassword ? 'text' : 'password'}
            value={value}
            placeholder={placeholder}
            InputRightElement={
              <Button
                variant="ghost"
                testID="show-password-icon"
                accessibilityLabel={t(`inputs.password.${showPassword ? 'showPassword' : 'hidePassword'}`)}
                onPress={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <Eye size={32} color="#494949" /> : <EyeSlash size={32} color="#494949" />}
              </Button>
            }
            {...rest}
          />
        </Stack>
        {errorMessage && <FormControl.ErrorMessage>{errorMessage}</FormControl.ErrorMessage>}
      </FormControl>
    </VStack>
  )
}

export default PasswordInput
